import { t as ZepIcon } from "../ZepIcon-BjEF3k8i.mjs";
import { jsx } from "react/jsx-runtime";
//#region src/components/ConfettiFill.tsx
const ConfettiFillIcon = ZepIcon((props) => /* @__PURE__ */ jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ jsx("path", {
		d: "M7.585 8.331c.34-.06.687.049.93.292l6.861 6.86a1.054 1.054 0 0 1-.305 1.7L4.99 21.807l-.001-.001a2.103 2.103 0 0 1-2.79-2.8L6.814 8.928c.143-.313.431-.536.77-.597Zm11.257 11.561a1.053 1.053 0 0 1 0-2.105 1.053 1.053 0 0 1 2.106 0 1.053 1.053 0 0 1 0 2.105 1.053 1.053 0 0 1-2.106 0Zm1.85-8.914a1.053 1.053 0 0 1 .51 2.041l-2.105.526a1.053 1.053 0 0 1-.51-2.04l2.105-.527ZM14.94 7.57a1.052 1.052 0 0 1 1.488 1.488l-1.052 1.053a1.052 1.052 0 0 1-1.489-1.489l1.053-1.052ZM4.107 5.157a1.052 1.052 0 1 1 0-2.105 1.052 1.052 0 0 1 2.105 0 1.053 1.053 0 0 1 .107 2.1l-.107.005-.006.108a1.052 1.052 0 0 1-2.099-.108Zm14.735 0a1.052 1.052 0 1 1 0-2.105 1.053 1.053 0 0 1 2.106 0 1.053 1.053 0 0 1 .106 2.1l-.106.005-.007.108a1.052 1.052 0 0 1-2.099-.108Zm-7.863-2.36a1.053 1.053 0 0 1 2.043.51l-.527 2.105a1.053 1.053 0 0 1-2.042-.51l.526-2.104Z",
		fill: props.fill || "currentColor"
	})
}));
//#endregion
export { ConfettiFillIcon };
